import { Vue, Component, Watch, Prop, } from 'vue-property-decorator';
import { wait } from '../../utility';
import { TabPanel } from '../sidewindow/tab-panel';

@Component({
  name: 'GridLayout'
})
export default class GridLayout extends Vue {

  @Prop({ default: () => [] }) tabs;
  @Prop({ required: false, default: () => [] }) options; // = [defaultOption];
  @Prop({ required: false, default: () => [] }) shareOptions; // = [defaultOption];
  @Prop({ required: false, default: () => [] }) menu; // = [defaultOption];

  @Prop({ required: false, default: '820' }) tabBodyColor;
  @Prop({ required: false, default: '3' }) tabPanelColor;


  @Prop({ default: false }) loading; // = [defaultOption];

  @Prop({ default: false, default: true }) showTabs; // = [defaultOption];

  initialTabRouted = false;
  @Watch('loading', { immediate: true })
  async onLoadingChange(to, from) {
    setTimeout(() => {
      // console.log('loading to', to,
      //   'tab', this.$route.params.tab,
      //   'itr', this.initialTabRouted,);
      if (!this.initialTabRouted) {
        this.initialTabRouted = true;
        this.loadingToTabSelect(this.$route.params.tab);
      }
    }, 1000);
  }
  @Watch('$route', { immediate: true, deep: true })
  onRouteChange(to, from) {
    // console.log({ 'dt-grid-layout.js:35 to': to.params.tab, initialTabRouted: this.initialTabRouted });
    // if (to.params.tab) {
    //   const tabRoute = to.params && to.params.tab;
    //   if (to?.params?.tab !== from?.params?.tab && !this.initialTabRouted) {
    //     console.log({ 'dt-grid-layout.js:39 tabRoute': tabRoute });
    //     this.initialTabRouted = true;
    //     this.loadingToTabSelect(this.$route.params.tab);
    //   }
    // }
  }

  mappedTabs = null;

  mounted() {
    console.log({ "Mounted GridLayout": this.$route });
  }

  get isLoading() {
    // console.log({ "isLoading": this.loading });

    if (this.isTabbed) {
      this.syncMapTabs();
    }

    return this.loading;
  }

  selectedBox = null;
  highlightedTab = null;
  tabClickFlag = null;

  syncMapTabs() {
    setTimeout(() => {
      const elOffset = this.$refs?.['glayout']?.offsetTop;
      this.mappedTabs = this.tabs.map(tab => {
        const tabEl = this.$el?.querySelector(`.dt-grid-tab#${tab.route}`);
        return [tab.route, tabEl?.offsetTop ? tabEl?.offsetTop - elOffset : 0];
      });

      if (!this.highlightedTab) {
        this.highlightedTab = this.mappedTabs?.[0]?.[0];
      }

    }, 1000);
  }

  get isTabbed() {
    if (this.tabs?.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  onGridBoxSelected(payload) {
    // console.log({ "selectedBox": payload });
    this.selectedBox = payload;
  }

  onLayoutScroll(element) {
    // console.log({ "element": element });

    if (this.tabClickFlag) {
      // console.log({ "this.tabClickFlag": this.tabClickFlag });
      return;
    }

    const scrollTop = element.target.scrollTop;

    const newHighlightedTab = this.mappedTabs?.find(([tab, top], index) => {
      if (scrollTop >= top && (scrollTop < this.mappedTabs?.[index + 1]?.[1] || index == this.mappedTabs?.length - 1)) {
        return true;
      } else {
        return false;
      }
    })?.[0];

    if (newHighlightedTab != this.highlightedTab) {
      this.$router.push({
        ...this.$route,
        params: {
          ...this.$route.params,
          tab: newHighlightedTab,
        }
      })
    }

    this.highlightedTab = newHighlightedTab;

    // console.log({ scrollTop, "this.highlightedTab": this.highlightedTab?.[0], "mappedTabs": this.mappedTabs });
  }

  async routeToTabSelect(value) {
    this.tabClickFlag = true;
    await wait(3000);
    // this.highlightedTab = value.route;
    // console.log({'dt-grid-layout.js:131 this.highlightedTab' : this.highlightedTab});
    const tabEl = document.querySelector(`.dt-grid-tab#${value.route}`) || document.querySelector(`.dt-grid-tab`);
    tabEl.scrollIntoView({
      behavior: 'smooth'
    });
    await wait(1000);
    this.tabClickFlag = false;
  }
  async loadingToTabSelect(value) {
    console.log({ 'dt-grid-layout.js:140 loadingToTabSelect': value });
    this.tabClickFlag = true;
    const tabEl = document.querySelector(`.dt-grid-tab#${value}`) || document.querySelector(`.dt-grid-tab`);
    // console.log({ "tabEl": tabEl });
    tabEl.scrollIntoView({
      behavior: 'smooth'
    });
    this.highlightedTab = value;
    await wait(1000);
    this.tabClickFlag = false;
    // }
  }
  tabSelected() { }
  async onTabSelected(value) {
    // console.log({ "value": value, });
    this.$emit('tabClicked', value);
    this.highlightedTab = value.route;
    // console.log({ "highlightedTab": this.highlightedTab });
    this.tabClickFlag = true;
    const tabEl = document.querySelector(`.dt-grid-tab#${value.route}`) || document.querySelector(`.dt-grid-tab`);
    tabEl.scrollIntoView({
      behavior: 'smooth'
    });
    this.$router.push({
      ...this.$route,
      params: {
        ...this.$route.params,
        tab: this.highlightedTab,
      }
    });
    await wait(1000);
    this.tabClickFlag = false;
  }

  onOptionClicked(e) {
    this.$emit('optionClicked', e);
  }

  render(h) {
    // const scopedSlots = {
    //   // tabPanelRight: () => this.$slots.tabPanelRight,
    //   tabPanelRight: () => <h1 class="dt-icon-container">dt-icon-container</h1>,
    // }
    // scopedSlots={scopedSlots}

    // console.log({ "GridLayout Rendered ": this.$slots.default });

    // componentInstance._props.id
    const tabRoutes = this.tabs.map(t => t.route);
    // console.log({ 'dt-grid-layout.js:182 invisibleTabs tabRoutes': tabRoutes });
    // const invisibleTabs = this.$slots.default?.filter(slot => {
    //   const slotId = slot.componentOptions?.propsData?.id;
    //   // console.log('dt-grid-layout.js:183 invisibleTabs slot',);
    //   return !tabRoutes.includes(slotId) && slotId != undefined && slotId != '';
    // });

    // console.log({ 'dt-grid-layout.js:183 invisibleTabs': invisibleTabs });

    const childrenWithStyles = this.$slots.default.map((vnode) => {
      const slotId = vnode.componentOptions?.propsData?.id;
      // console.log({'dt-grid-layout.js:193 slotId' : slotId});
      let isInvisible;
      if (slotId == '' || slotId == undefined) {
        // console.log({'dt-grid-layout.js:195 slotId' : slotId});

        if (!tabRoutes.includes('overview')) {
          isInvisible = true;
        }
      } else {
        isInvisible = !tabRoutes.includes(slotId);
      }


      // Apply inline styles
      return {
        ...vnode,
        data: {
          ...vnode.data,
          style: {
            display: isInvisible ? 'none' : 'inherit',
          },
        },
      };
    });

    // get slot tabPanelRight
    const tabPanelRight = this.$slots.tabPanelRight;

    //  this.tabs?.filter(tab => tab.route );

    return (
      <div class="dt-grid-layout-container" style={{
        '--dtgrid-tab-body-color': `var(--bc-${this.tabBodyColor})`,
        '--dtgrid-tab-panel-color': `var(--bc-${this.tabPanelColor})`
      }}>
        {this.showTabs && this.isTabbed && <TabPanel
          tabs={this.tabs}
          options={this.options}
          shareOptions={this.shareOptions}
          menu={this.menu}
          onOptionClicked={this.onOptionClicked}
          tabPanelRight={tabPanelRight}
        />}
        <div class={`dt-grid-layout ${this.isLoading ? 'grid-loading' : ''}`} ref="glayout" onScroll={this.onLayoutScroll}>
          {childrenWithStyles}
        </div>
      </div>
    );
  }
}

@Component({
  name: 'GridRow'
})
export class GridRow extends Vue {
  render(h) {
    return (
      <div class="dt-grid-row">
        {this.$slots.default}
      </div>
    );
  }
}
@Component({
  name: 'GridColumn'
})
export class GridColumn extends Vue {
  @Prop({ required: false, default: '1' }) f;

  render(h) {
    return (
      <div class="dt-grid-column" style={{
        flex: this.f
      }}>
        {this.$slots.default}
      </div>
    );
  }
}
